<template>
  <div>
    <b-row>
      <b-col cols="2">
        <b-button  variant="success" @click="addIPTVcard">{{ $t('Add') }}</b-button>
      </b-col>
      <b-col cols="6">
        <b-form-group :label="$t('Select account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="selectedAccount" :options="currentRow.accounts">
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table small striped hover :items="IPTVActivationCards" :fields="IPTVActivationCardsFields"/>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'

export default {
  props: {
    currentRow: null
  },
  data () {
    return {
      newIPTVcard: {
        'account_id': 0
      },
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      editDocumentImage: require('@/assets/img/document_edit.png'),
      selectedAccount: null,
      IPTVActivationCards: [],
      IPTVActivationCardsFields: [
        { key: 'access_card_number', label: this.$i18n.t('Access card'), sortable: true },
        { key: 'part_1', label: this.$i18n.t('Part 1'), sortable: true },
        { key: 'part_2', label: this.$i18n.t('Part 2'), sortable: true },
        { key: 'part_3', label: this.$i18n.t('Part 3'), sortable: true },
        { key: 'part_4', label: this.$i18n.t('Part 4'), sortable: true },
        { key: 'part_5', label: this.$i18n.t('Part 5'), sortable: true },
        { key: 'part_6', label: this.$i18n.t('Part 6'), sortable: true },
        { key: 'namePeriodicType', label: this.$i18n.t('Status'), sortable: true }
      ]
    }
  },
  methods: {
    load () {
      this.selectedAccount = this.currentRow.accounts.length ? this.currentRow.accounts[0] : null
    },
    async reloadActivationCard () {
      if (this.selectedAccount) {
        let tmpIPTVActivationCards = await axiosInstance.get(this.$store.getters.API_USERS_ACTIVATION_CODES + '?account_id=' + this.selectedAccount).then(response => { return response.data })
        for (let i in tmpIPTVActivationCards) {
          switch (tmpIPTVActivationCards[i].state) {
            case 32768055:
              tmpIPTVActivationCards[i].namePeriodicType = this.$i18n.t('Used')
              break
            case 32768006:
              tmpIPTVActivationCards[i].namePeriodicType = this.$i18n.t('Active card')
              break
          }
        }
        this.IPTVActivationCards = tmpIPTVActivationCards
      }
    },
    addIPTVcard () {
      this.newIPTVcard.account_id = this.selectedAccount
      axiosInstance.post(this.$store.getters.API_USERS_ACTIVATION_CODES, this.newIPTVcard).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
          this.reloadActivationCard()
        }
      })
    }
  },
  watch: {
    selectedAccount: function () {
      this.reloadActivationCard()
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/iptvActivationCards/main.vue